import { render, staticRenderFns } from "./OrgProvinceHistorical.vue?vue&type=template&id=7bc0b5e6&"
import script from "./OrgProvinceHistorical.vue?vue&type=script&lang=js&"
export * from "./OrgProvinceHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports